<template>
  <div class="apply-edit-detail">
    <a-card title="申请明细" :loading="!creditInfo" class="card">
      <credit-info-view
        ref="creditInfoView"
        :type="type"
        :credit-info="creditInfo"
        :risk-evaluation="riskEvaluation"
        :has-risk-modal="hasRiskModal"
        @getModalFromChild="getModalFromChild"
        @getSegmentFromChild="getSegmentFromChild"
        @getLinkFromChild="getLinkFromChild"
      />

      <!-- 信用类型申请表格 -->
      <div class="apply-tables">
        <!-- 信用限额table -->
        <limit-extension-table
          :type="type"
          :data-source="limitExtensionList"
          :base-info="baseInfo"
        ></limit-extension-table>
      </div>
      <!-- 申请原因及备注 -->
      <!-- <apply-reason-remark
        :content="(creditInfo && creditInfo.remark) || ''"
        :attachments="attachments"
      /> -->
    </a-card>
  </div>
</template>

<script>
import Vue from 'vue'
import CreditInfoView from '../components/ApplyDetail/CreditInfoView.vue'
import LimitExtensionTable from './LimitExtensionTable.vue'
// import ApplyReasonRemark from '../components/ApplyDetail/ApplyReasonRemarkView.vue'
import { CREDIT_TYPE_VALUE_OBJ } from '../const'

export default {
  name: 'ApplyViewDetail',
  data() {
    return {
      title: '申请明细',
      gutter: { xs: 8, sm: 16, md: 24, lg: 24 },
    }
  },
  props: [
    'creditInfo',
    'type',
    'limitExtension',
    'baseInfo',
    'attachments',
    'riskEvaluation',
    'hasRiskModal',
  ],
  computed: {
    limitExtensionList() {
      return [{ key: 1, ...this.limitExtension }]
    },
  },
  methods: {
    validate() {
      const checkCreditInfoView = this.$refs.creditInfoView.validate()
      if (checkCreditInfoView) {
        return checkCreditInfoView
      }
      return false
    },
    // 校验type!=1时，增加判断“申请后总额度”vs有效期内限额条件中的“控货金额”合计数
    validateTotalAmount(confirmSkipStatus) {
      return new Promise(resolve => {
        const limitControlAmount = this.baseInfo.limitControlAmount //控货金额
        let totalWithRoadAmount =
          this.$refs.loanTable.getTotalWithRoadAmount() ||
          this.$refs.specialTable.getTotalWithRoadAmount() //申请后总额度
        if (
          this.type != CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE &&
          limitControlAmount &&
          totalWithRoadAmount > limitControlAmount &&
          !confirmSkipStatus
        ) {
          this.$confirm({
            title: '提示',
            content: `超过${Vue.filter('formatAmount')(
              limitControlAmount,
            )}需要控货，请做好控货操作, 是否继续?`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              resolve()
            },
            onCancel: () => {
              this.$message.info('已取消提交')
            },
          })
        } else {
          resolve()
        }
      })
    },
    getModalFromChild(query) {
      this.$emit('getModalFromCC', query)
    },
    getSegmentFromChild(query) {
      this.$emit('getSegmentFromCC', query)
    },
    getLinkFromChild(query) {
      this.$emit('getLinkFromCC', query)
    },
  },
  components: {
    CreditInfoView,
    // ApplyReasonRemark,
    LimitExtensionTable,
  },
}
</script>

<style lang="less" scoped>
.apply-tables {
  .ant-table-wrapper {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.apply-reason-memo {
  margin: 20px 0;
}
</style>
